import React from "react";
import Stack from "@mui/material/Stack";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import ViewDetails from "../../components/Manufacturer/ViewDetails";
import { Typography } from "@mui/material";
import DialogEditMap from "components/Manufacturer/Models/DialogEditMap";
import { ManufacturerTableApi } from "stores/ManufacturerStore/ManufacturerApi";

class ViewDetailsContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openUpdate: false,
      openEdit: false,
      power: "",
      time: "",
      id: null,
      AddAmenitiesConfirmDaialog: false,
    };
  }

  componentDidMount() {
    let manufacturerId;
    if (this.props?.location?.manufacturerDetailsId?.id) {
      localStorage.setItem(
        "manufacturerId",
        JSON.stringify(this.props?.location?.manufacturerDetailsId?.id)
      );
      manufacturerId = this.props?.location?.manufacturerDetailsId?.id;
    } else {
      manufacturerId = localStorage.getItem("manufacturerId");
      if (manufacturerId) manufacturerId = JSON.parse(manufacturerId);
    }
    if (manufacturerId) {
      this.props.getDetailsTableAction({ id: manufacturerId });
    }
  }

  handleClickOpen = (id, max_khw, time) => {
    this.setState({ openEdit: true, id: `${id}`, power: max_khw, time: time });
  };

  handleOnChange = (e, name) => {
    if (name === "max_khw") {
      this.setState({ power: e.target.value });
    } else if (name === "time") {
      this.setState({ time: e.target.value });
    }
  };

  handleEditUpdateAmanity = () => {
    this.setState({ openEdit: false });
  };

  handleClickSubmit = async () => {
    const { id, power, time } = this.state;
    let manufacturerId;

    if ((power, time)) {
      await ManufacturerTableApi.UpdateMapApi({
        id,
        max_khw: power,
        time: time,
      });
      if (this.props?.location?.manufacturerDetailsId?.id) {
        localStorage.setItem(
          "manufacturerId",
          JSON.stringify(this.props?.location?.manufacturerDetailsId?.id)
        );
        manufacturerId = this.props?.location?.manufacturerDetailsId?.id;
      } else {
        manufacturerId = localStorage.getItem("manufacturerId");
        if (manufacturerId) manufacturerId = JSON.parse(manufacturerId);
      }
      if (manufacturerId) {
        this.props.getDetailsTableAction({ id: manufacturerId });
      }
      this.setState({ openEdit: false });
    }
  };

  AddhandleAmenitiesClose = () => {
    this.setState({ AddAmenitiesConfirmDaialog: false });
  };

  render() {
    const data = this.props?.DetailsTableList;
    const manudata = this.props?.location?.manufacturerDetailsId?.name;

    return (
      <Grid item xs={12}>
        <Stack p={0.5} mt={2}>
          <Breadcrumbs
            sx={{ fontSize: "14px", color: "#0DA861" }}
            separator="›"
            aria-label="breadcrumb"
          >
            <Link
              sx={{ fontSize: "14px" }}
              underline="hover"
              color="#A2A7AE"
              href="/manufacturer "
            >
              Vehicle details
            </Link>
            <Typography sx={{ fontSize: "14px" }} color="#0DA861">
              {this.props?.location?.manufacturerDetailsId?.name}
            </Typography>
          </Breadcrumbs>
        </Stack>

        <Grid>
          <Paper sx={{ p: 3, mt: 1 }}>
            <ViewDetails
              data={data}
              manudata={manudata}
              onclickopenDailog={this.handleClickOpen}
            />

            <DialogEditMap
              handleClose={this.handleEditUpdateAmanity}
              open={this.state.openEdit}
              power={this.state.power}
              time={this.state.time}
              handleOnChange={(e, f) => {
                this.handleOnChange(e, f);
              }}
              handleClickSubmit={this.handleClickSubmit}
            />
          </Paper>
        </Grid>
      </Grid>
    );
  }
}
export default ViewDetailsContainer;
